<div class="row">
  <div class="col-lg-12">
    <div class="card">
      <div class="card-body">
        <div class="divContainer">
          <div class="card">
            <div class="card-body">
              <button type="button" id="btnLoadList" (click)="getstatusList()" style="display:none">Get</button>
              <button type="button" id="btn_AddNew" class="btn btn-block btn-primary float-sm-right" (click)="show()" style="display:none">Add New</button>
              <button type="button" id="btnColSave" class="btn btn-block btn-primary float-sm-right" style="display:none">Columns</button>
              <table #dataTable class="display" style="width:100%"></table>
            </div>
          </div>
        </div>

        <!-- The Modal -->
        <div class="modal" id="myModal" [style.display]="showModal ? 'block' : 'none'">
          <div class="modal-dialog">
            <div class="modal-content" id="divStatusCT">

              <!-- Modal Header -->
              <div class="modal-header">
                <h4 class="modal-title">{{ title }}</h4>
                <button type="button" class="close" data-dismiss="modal" (click)="hide()">&times;</button>
              </div>

              <!-- Modal body -->
              <div class="modal-body">
                <form #form="ngForm" id="frmStatus">
                  <div class="col-sm-12">
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="txtStatusName" class="control-label">Status Name<em>*</em></label>
                          <input class="form-control" type="text" maxlength="15" id="txtStatusName">
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col">
                        <div class="form-group">
                          <label for="txtModuleName" class="control-label">Module Name<em>*</em></label>
                          <input class="form-control" type="text" maxlength="50" id="txtModuleName">
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
              <!-- Modal footer -->
              <div class="modal-footer">
                <button type="button" class="btn btn-outline-danger waves-effect waves-light" data-dismiss="modal" (click)="hide()">Close</button>
                <button type="button" class="btn btn-outline-success waves-effect waves-light" (click)="updateStatusDetails()">Add / Update</button>
              </div>
            </div>
            <div id="LoadingImagePopup">
              <img src="assets/Images/loader.gif" class="imgLoadimg" alt="Loading" />
            </div>
          </div>

        </div>
      </div>
    </div>
  </div>
</div>
